import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'patient-score-card-small',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './score-card-small.component.html',
  styleUrl: './score-card-small.component.css'
})
export class ScoreCardSmallComponent {
  @Input() score: number = 0;
  
  private router = inject(Router);

  get strokeDashArray(): string {
    const radius = 42;
    const circumference = Math.PI * radius; // Half circle
    const progress = (this.score / 100) * circumference;
    return `${progress} ${circumference}`;
  }

  getGaugeColor(): string {
    if (this.score < 20) return '#D32F2F'; // Red
    if (this.score < 40) return '#FF9800'; // Orange
    if (this.score < 60) return '#FFD600'; // Yellow
    if (this.score < 80) return '#C6E02B'; // Lime
    return '#2E7D32'; // Green
  }

  navigateToDetails() {
    this.router.navigate(['/assessment-details']);
  }
}
